import { createSerializer, parseAsBoolean } from 'nuqs';

/** URL state for the product PDF download page. */
export const productPdfParsers = {
  /** Appends the ingredient, processing, packaging and transport tables. */
  breakdown: parseAsBoolean.withDefault(false),
};

/**
 * Builds the download page's search string on top of its path. Values equal
 * to their defaults are omitted, so the summary link stays bare.
 */
export const serializeProductPdfParams = createSerializer(productPdfParsers);
